import { create } from 'zustand';

interface ThemeColors {
  mainBgColor: string;
  loadingColor: string;
  themeColor: string;
  themeColorDark: string;
  themeColorLight: string;
  secondaryColor: string;
  thirdColor: string;
  mainTextColor: string;
  mainTitleColor: string;
  progressBarColor: string;
  homeBgColor: string;
  homeTextBlackColor: string;
  buttonGreenColor: string;
  buttonPurpleColor: string;
  buttonRedColor: string;
  buttonBlueColor: string;
  buttonOrangeColor: string;
  buttonCyanColor: string;
  buttonGrayColor: string;
  buttonVibrantColor: string; // 鲜亮的粉紫色
  calendarLearnedColor: string;
  correctAnswerColor: string;
  correctAnswerColorLight: string;
  wrongAnswerColor: string;
  wrongAnswerColorLight: string;
  homeTitleColor: string;
  dashboardMainColor: string;
  extracurricularMainColor: string;
  gameCenterMainColor: string;
  panelTitleColor: string;
  panelBgColor: string;
  streakColor: string;
  streakOutlineColor: string;
}

const theme: ThemeColors = {
  mainBgColor: "#F8F5EE",
  loadingColor: "#FA6467",
  themeColor: "#FA6467",
  themeColorDark: "#E85559",
  themeColorLight: "#ffe5e5",
  secondaryColor: "#FA6467",
  thirdColor: "#FFF1C9",
  mainTextColor: "#735648",
  mainTitleColor: "#735648",
  progressBarColor: "#F2B80E",
  homeBgColor: "#faf8ef",
  homeTextBlackColor: "#292929",
  buttonGreenColor: "#00A88A",
  buttonPurpleColor: "#8E6DFF",
  buttonRedColor: "#FA6467",
  buttonBlueColor: "#0B77C8",
  buttonOrangeColor: "#FFA73B",
  buttonCyanColor: "#00B2E9",
  buttonGrayColor: "#808080",
  buttonVibrantColor: "#FF6B9D", // 鲜亮的粉紫色
  calendarLearnedColor: "#FFDBDC",
  correctAnswerColor: "#00A88A",
  correctAnswerColorLight: "#9AFAC0",
  wrongAnswerColor: "#FA6467",
  wrongAnswerColorLight: "#FFC4C5",
  homeTitleColor: "#FA6467",
  dashboardMainColor: "#847AD9",
  extracurricularMainColor: "#38B48B",
  gameCenterMainColor: "#3A80BA",
  panelTitleColor: "#FA6467",
  panelBgColor: "#FAF8EF",
  streakColor: "#B95CEE",
  streakOutlineColor: "#B95CEE"
};


interface ThemeStore {
  colors: ThemeColors;
}

const useThemeStore = create<ThemeStore>()(() => ({
  colors: theme,
}))

export default useThemeStore;